<template>
  <div class="thumb-box"> 
    <picture class="thumb-box__img embed-responsive embed-responsive-16by9">
      <img class="embed-responsive-item" v-lazy="thumb" />
    </picture>

    <slot />
  </div>
</template>

<script>
  export default {
    props: {
      thumb: { type: String, default: '' },
      hasHover: { type: Boolean, default: true },
    }
  }
</script>

<style scoped lang="scss">
  .thumb-box {
    position: relative;
    border-radius: 5px;
    width: 110px;

    &__img { 
      border-radius: 4px;
    }

    &.hasHover:hover {
      &:after { opacity: 1 }
      &:before { opacity: 1 }
    }
  }
</style>